<template>
  <div class="systemParameter">

    <div class="centerStructure">
      <div class="searchBox">
        <span class="inp">参数名称：</span>
        <el-input class="cname" v-model.trim="parameterNames" placeholder="输入参数名称" clearable></el-input>
        <span class="inp">参数描述：</span>
        <el-input class="cname" v-model.trim="parameterDescs" placeholder="输入参数描述" clearable></el-input>
        <el-button type="primary" @click="listSystemParameters" icon="el-icon-search">查询</el-button>
      </div>
      <el-table :data="tableData" border ref="singleTable" style="width: 100%" height="calc(100% - 84px)">
        <el-table-column fixed type="index" header-align="center" align="center" width="50">
        </el-table-column>
        <template v-for="item in tableTitle">
          <el-table-column :header-align="item.headerAlign" :align="item.align" :key="item.index" :label="item.label"
                           :prop="item.prop"
                           :width="item.width" v-if="item.prop != 'operation'" show-overflow-tooltip>
          </el-table-column>
          <el-table-column v-if="item.prop == 'operation'" :label="item.label" :key="item.prop" header-align="center"
                           align="center"
                           :width="item.width">
            <template slot-scope="scope">
              <span class="tableicon" v-show="$root.$permissionMap.has('UpdateSystemParameter')"><i @click="opendialog(scope)" class="el-icon-edit"></i></span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber"
                     :page-sizes="[20, 30]" :page-size="20" layout="total, sizes, prev, pager, next" :total="pagetotal">
      </el-pagination>
    </div>
    <el-dialog :title="title" :visible.sync="opendiaflag" :close-on-click-modal="false" :modal-append-to-body="false" top="10vh" width="680px"
               @close="closeDialog">
      <div class="formbox">
        <el-form :rules="rules" :model="formData" label-width="100px" ref="ruleForm">
          <el-form-item label="参数名称：">
            <el-input v-model="formData.parameterName" disabled></el-input>
          </el-form-item>

          <el-form-item label="参数描述：">
            <el-input type="textarea" v-model="formData.parameterDesc" disabled></el-input>
          </el-form-item>

          <el-form-item label="参数值：" prop="parameterValue">
            <el-input type="textarea" v-model.trim="formData.parameterValue"></el-input>
          </el-form-item>

          <div class="inline" style="display:flex">
            <el-form-item label="添加版本：">
              <el-input class="wh200" v-model="formData.systemVersion" disabled></el-input>
            </el-form-item>
            <el-form-item label="创建时间：">
              <el-input class="wh200" v-model="formData.createTime" disabled></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
				<el-button @click="opendiaflag=false">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')" :disabled="permissionFlag">提 交</el-button>
			</span>
    </el-dialog>
  </div>
</template>

<script>
import {
  Mixins
} from '@/config/mixins/mixins'
import {
  $http
} from '@/config/api/axios'
import SearchDialog from '@/components/custom/Searchdialog'
import Tree from "@/components/common/Tree"

export default {
  name: "systemParameter",
  mixins: [Mixins],
  components: {
    SearchDialog,
    Tree,
  },
  data() {
    return {
      parameterRegular: "",
      parameterMsg: "",
      tableTitle: [
        {
          prop: "operation",
          label: '操作',
          width: '60px',
          align: 'center',
          headerAlign: 'center',
          show: true
        },
        {
          prop: "parameterName",
          label: '参数名称',
          width: '260px',
          align: 'left',
          headerAlign: 'center',
          show: true
        },
        {
          prop: "parameterValue",
          label: '参数值',
          width: '140px',
          align: 'left',
          headerAlign: 'center',
          show: true
        },
        {
          prop: "parameterDesc",
          label: '参数描述',
          width: '',
          align: 'left',
          headerAlign: 'center',
          show: true
        },
        {
          prop: "systemVersion",
          label: '添加版本',
          width: '80px',
          align: 'center',
          headerAlign: 'center',
          show: false
        },
        {
          prop: "createTime",
          label: '创建时间',
          width: '160px',
          align: 'center',
          headerAlign: 'center',
          show: true
        },
        {
          prop: "updateTime",
          label: '更新时间',
          width: '160px',
          align: 'center',
          headerAlign: 'center',
          show: true
        },

      ],
      tableData: [],
      //查询条件
      parameterDescs: '',
      parameterNames: '',
      //分页
      pageSize: 20, //条数
      pageNumber: 1, //页数
      pagetotal: 0, //总页数

      title: '系统参数信息',
      opendiaflag: false,
      // form字段↓
      formData: {
        parameterName: '',
        parameterDesc: '',
        parameterValue: '',
        systemVersion: '',
        createTime: '',
      },
      rules: {
        parameterValue: [{
          required: true,
          message: '参数值不能为空',
          trigger: 'blur'
        }, {
          validator: null,
          trigger: 'blur'
        }]
      },
      treeDemoData: [],
      jsonTree: {},
      expandNode: [],
      permissionFlag:true,
    }
  },
  methods: {
    getPermission(){
      let permissions = JSON.parse(localStorage.getItem('permissions'));
      for (let i = 0; i < permissions.length; i++) {
        if(permissions[i]=="UpdateSystemParameter"){
          this.permissionFlag =false;
        }
      }
    },
    handleSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(currentPage) {
      this.pageNumber = currentPage;
      this.listSystemParameters();
    },
    tableDragClose(visible, changedData) {
      /*  this.tableDragVisible = visible;*/
      this.tableTitle = changedData ? JSON.parse(changedData) : this.tableTitle
    },
    //查数据
    listSystemParameters() {
      this.selfLoadingOpen('.centerStructure');
      let params = {
        parameterName: this.parameterNames,
        parameterDesc: this.parameterDescs,
        pageSize: this.pageSize,
        pageNumber: this.pageNumber
      }
      $http("get", "systemParameter/listSystemParameters", params)
          .then((res) => {
            if (res.status == 'SUCCESS') {
              this.tableData = res.data;
              this.pagetotal = res.count;
              this.selfLoadingClose();
            }else if(res.status == 'NORESOURCES'){
              this.tableData = [];
              this.pagetotal =0;
              this.selfLoadingClose();
            }else{
              this.$message({
                type: 'error',
                message: res.message
              });
              this.selfLoadingClose();
            }
          })
    },
    opendialog(scope) {
      this.formData.id = scope.row.id;
      this.formData.createTime = scope.row.createTime;
      this.formData.parameterDesc = scope.row.parameterDesc;
      this.formData.parameterName = scope.row.parameterName;
      this.formData.parameterValue = scope.row.parameterValue;
      this.formData.systemVersion = scope.row.systemVersion;
      this.parameterRegular = scope.row.parameterRegular;
      this.parameterMsg = scope.row.parameterMsg;
      this.checkTheValue(this.parameterRegular, this.parameterMsg);
      this.opendiaflag = true;
    },
    submitForm(ref) {
      this.$refs[ref].validate((valid) => {
        if (valid) {
          this.opendiaflag = false;
          let params = {
            id: this.formData.id,
            parameterValue: this.formData.parameterValue,
            parameterName: this.formData.parameterName
          };
          $http("post", "systemParameter/updateSystemParameter", params)
              .then((res) => {
                if (res.status == 'SUCCESS') {
                  this.$message({
                    type: 'success',
                    message: res.message
                  });
                  this.handleCurrentChange(1);

                } else {
                  this.$message({
                    type: 'error',
                    message: res.message
                  });
                }
              })
        } else {
          return false;
        }
      })
    },
    checkTheValue(parameterRegular, parameterMsg) {
      //自定义效验
      let checkValue = (rule, value, callback) => {
        let reg1 = new RegExp(parameterRegular);
        let flag = reg1.test(value);
        if (!flag) {
          return callback(new Error(parameterMsg));
        } else {
          callback();
        }
      };
      this.rules.parameterValue[1].validator = checkValue;
    },
    clear(formName) {
      this.$refs[formName].clearValidate(); //清空表单验证规则
    },
    closeDialog() {
      this.clear('ruleForm')
    }
  },
  created() {

  },
  mounted() {
    this.listSystemParameters();
    this.getPermission();
  },
  activated() {
    this.$refs.singleTable.doLayout() // 路由切换时对table重新布局
  },
}
</script>

<style lang="less">
.systemParameter {
  position: relative;
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;

  .tableicon {
    cursor: pointer;
    margin: 0 8px;
    color: #4980d7;
  }

  .theText {
    width: 100%;
    height: 70px;
  }
}
</style>
